<template>
    <div class="zechen">
        <div class="title">
            <b>{{ $t("case.zechen.name") }}</b>
            <span>【{{ $t("case.zechen.business") }}】</span>
        </div>
        <div class="business">
            <h4>{{ $t("case.zechen.title") }}</h4>
            <div class="box">
                {{ $t("case.zechen.details") }}
            </div>
            <div class="content">
                <div><img src="../../../public/zechen.png" alt=""/></div>
                <div>
                    应用模块：WMS、MES、QMS、IoT、SaaS
                    <br>1.WMS：原材料管理、半成品、成品管理、SAP数据同步
                    <br>2.MES：工程管理、生产防错追溯、治工具管理、生产管理看 板、DIP及组装测试追溯
                    <br>3.QMS：质量管理、SPC、QTIME
                    <br>4.IoT：智能货架/镭雕机/烘烤柜/温湿度监控仪/上板机/印刷机/SPI/NPM贴片机/AOI/ERSA回流炉/下板机/X-ray/ICT/返修台/分板机/自动烧录机/组包装测试
                    /自动化测试仪/点胶机/密封性测试仪/FCT/老化柜/镜头对焦仪/ERSA选择性波峰焊
                    <br>5.供应商云注册平台
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.zechen {
    margin: 0px 150px;
    padding-top: 100px;
}

.title {
    font-size: 18px;
    color: #121212;
    line-height: 24px;
    padding-bottom: 40px;
    border-bottom: 1px solid #dfdfdf;
}

.title > span {
    font-size: 14px;
    color: #7e7e7c;
}

.business {
    font-size: 14px;
    color: #7e7e7c;
    line-height: 30px;
}

.business > h4 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 800;
    color: #121212;
}

.box {
    margin-bottom: 40px;
}

.content {
    display: flex;
    align-items: center;
    margin-bottom: 80px;
}

.business > .content img {
    width: 700px;
    height: 400px;
    margin-right: 80px;
}

</style>
